export default __webpack_public_path__ + "static/media/game3.46cbf18d.png";